module.exports = __webpack_public_path__ + "img/explorer.b1b10160.png";